var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-level --is-level-1 --is-mobile"},[_c('Heading',{attrs:{"title":"Fertige Präsente","subtitle":"Thematisch perfekt abgestimmt.","level":"1"}}),_c('LevelCatalog',{ref:"catalog",attrs:{"listItems":_vm.$store.getters.getListItemsLevel1Filtered.filter(function(product) {
          const price = _vm.getPriceRawForGroup(product, _vm.$store.getters.getUserGroupId, !_vm.$store.getters.getLevel1Filter.useB2cPrices) + _vm.getBoxPriceLvl1(product, _vm.$store.getters.getUserGroupId, !_vm.$store.getters.getLevel1Filter.useB2cPrices);
          if (
              price >= _vm.$store.getters.getLevel1Filter.priceMin &&
              price <= _vm.$store.getters.getLevel1Filter.priceMax
          ) {
              return true;
          }
          return false;
      })}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }